import { Box } from '@mui/material';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BrochurePage from '../components/pages/BrochurePage/BrochurePage';
import NoticeDetailPage from '../components/pages/NoticeDetailPage/NoticeDetailPage';
import NoticeListPage from '../components/pages/NoticeListPage/NoticeListPage';
import noticeList from '../data/notice.json';

const Notice = () => {
  return <Box>Notice</Box>;
};

const Brochure = () => {
  return (
    <Box>
      <BrochurePage />
    </Box>
  );
};

const noticeHeader = [
  {
    name: 'No.',
    value: 'no',
    width: 10,
  },
  {
    name: 'Title',
    value: 'title',
    width: 50,
  },
  {
    name: 'File',
    value: 'file',
    width: 10,
  },
  {
    name: 'Writer',
    value: 'writer',
    width: 15,
  },
  {
    name: 'Date',
    value: 'date',
    width: 15,
  },
];

export default function NoticeRouter() {
  return (
    <Routes>
      <Route path='/' element={<Notice />} />
      <Route path='/list' element={<NoticeListPage noticeList={noticeList} headerList={noticeHeader} />} />
      <Route path='/detail' element={<NoticeDetailPage />} />
      <Route path='/brochure' element={<Brochure />} />
    </Routes>
  );
}
